import { z } from "zod";

/**
 * News webhook payload. The primary source is a daily ForexFactory JSON fetch
 * from the Worker cron. This endpoint is a FALLBACK for the MT5 news scraper
 * EA (Exa_NewsScraper.mq5) — same shape, HMAC-signed, routed to
 * POST /webhooks/news.
 */
export const NewsEventZ = z.object({
  id: z.string().min(1).max(64),
  eventName: z.string().min(1).max(256),
  currency: z.string().length(3),
  impact: z.enum(["high", "medium", "low"]),
  scheduledAt: z.number().int(), // ms epoch
  actual: z.string().nullable(),
  forecast: z.string().nullable(),
  previous: z.string().nullable(),
  source: z.enum(["forexfactory", "mt5-scraper"]).default("forexfactory"),
});
export type NewsEvent = z.infer<typeof NewsEventZ>;

export const NewsBatchZ = z.object({
  events: z.array(NewsEventZ).min(1).max(500),
  fetchedAt: z.number().int(),
});
export type NewsBatch = z.infer<typeof NewsBatchZ>;
